import { Image } from 'src/components/ui/Image'
import type { Video } from 'src/components/restructure/product/sections/GalleryImage/types/gallery-image'
import classNames from 'classnames'

type GalleryMovieProps = Video & {
  mode?: 'pdp' | 'fullscreen' | 'grid'
}

export const GalleryMovie = (props: GalleryMovieProps) => {
  const { url, videoType, mode = 'pdp' } = props

  const formatUrl = (sourceVideo: string) => {
    const replaceHost = sourceVideo.replace('youtu.be', 'youtube.com/embed')

    return replaceHost.concat(
      `${videoType === 'youtube' ? '?' : '&'}autoplay=1&mute=1&loop=1`
    )
  }

  const containerClasses = classNames('flex items-center relative isolate', {
    'h-full w-full': mode === 'pdp',
    'aspect-square w-full h-full': mode === 'grid',
    'w-full h-full max-w-[648px] max-h-[648px] aspect-square':
      mode === 'fullscreen',
  })

  const iframeClasses = classNames('w-full h-full z-[1]', {
    'min-h-[85vw] ls:min-h-[auto]': mode === 'pdp',
    'aspect-square': mode === 'grid' || mode === 'fullscreen',
  })

  return (
    <div className={containerClasses}>
      {mode === 'pdp' && (
        <div id="draggable-iframe" className="h-[85%] w-full absolute top-0" />
      )}
      <iframe
        className={iframeClasses}
        src={formatUrl(url)}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        data-testid="gallery-item-movie"
      />
    </div>
  )
}

export const GalleryMovieThumb = (props: Video) => {
  const { thumbnail, label } = props

  return (
    <Image
      src={
        thumbnail ??
        'https://decathlonstore.vtexassets.com/assets/vtex.file-manager-graphql/images/8b3268dc-70dd-4ef7-a2d0-1b9b879cd88c___473ae1e328085f4bb470f9f85d393465.png'
      }
      width={88}
      height={88}
      alt={label}
      style={{ objectFit: 'contain' }}
      loading="eager"
      preload
      className="w-[88px] bg-restructure-background-secondary mix-blend-multiply rounded-md"
      aria-label="Miniatura do video no carousel de thumbs das imagens"
    />
  )
}
